import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import { API } from 'utilities/api';

function readAndClearCookie(name) {
  const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
  if (match) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=None; Secure`;
    return decodeURIComponent(match[1]);
  }
  return null;
}

export default function OAuthCallback() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = readAndClearCookie('token');

    if (!token) {
      setError('Sign in failed. Please try again.');
      setTimeout(() => navigate('/', { replace: true }), 2500);
      return;
    }
    // Stamp the token, then fetch the profile to pick the right
    // landing surface. Platform admins go to /admin; everyone else
    // lands on the brand dashboard.
    login(token, null);
    API.getUserProfile()
      .catch(() => null)
      .then((profile) => {
        if (profile && typeof profile === 'object') login(token, profile);
        const target = profile?.is_platform_admin === true
          ? '/admin'
          : '/dashboard/brand/overview';
        navigate(target, { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #050510 0%, #0D0D2B 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: "'Inter', -apple-system, sans-serif",
    }}>
      <style>{`@keyframes tpo-spin { to { transform: rotate(360deg); } }`}</style>
      <div style={{ textAlign: 'center' }}>
        {!error ? (
          <>
            <div style={{
              width: 48, height: 48, borderRadius: '50%',
              border: '3px solid rgba(124,58,237,0.2)',
              borderTopColor: '#7C3AED',
              animation: 'tpo-spin 0.8s linear infinite',
              margin: '0 auto 16px',
            }} />
            <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 14, margin: 0 }}>
              Completing sign in…
            </p>
          </>
        ) : (
          <>
            <div style={{ fontSize: 32, marginBottom: 12 }}>⚠️</div>
            <p style={{ color: '#FCA5A5', fontSize: 14, margin: '0 0 8px' }}>{error}</p>
            <p style={{ color: 'rgba(255,255,255,0.35)', fontSize: 12, margin: 0 }}>Closing…</p>
          </>
        )}
      </div>
    </div>
  );
}
